export type TransitionTiming = Readonly<{
  discMs: number;
  extractionStepMs: number;
  totalMs: number;
}>;

export function transitionTiming(
  motion: "full" | "reduced",
  extractionSteps: number,
  passage: boolean,
  timing: "normal" | "review" = "normal",
): TransitionTiming {
  const multiplier = timing === "review" ? 0.5 : 1;
  if (motion === "reduced") {
    const discMs = 90 * multiplier;
    const extractionStepMs = extractionSteps === 0 ? 0 : (150 * multiplier) / extractionSteps;
    return Object.freeze({
      discMs,
      extractionStepMs,
      totalMs: discMs + extractionStepMs * extractionSteps,
    });
  }

  const discMs = (passage ? 300 : 270) * multiplier;
  const extractionBudget = passage ? 560 : 1150;
  const extractionStepMs =
    extractionSteps === 0 ? 0 : Math.min(330, extractionBudget / extractionSteps) * multiplier;
  return Object.freeze({
    discMs,
    extractionStepMs,
    totalMs: discMs + extractionStepMs * extractionSteps,
  });
}
